import React, { useMemo } from 'react'
import { Application } from "../../components/Application/Application";

export function ApplicationPage() {
  const applicationId = useMemo(() => {
    return document.getElementById('applicationId')?.value
  }, [])

  const appNonce = useMemo(() => {
    return document.getElementById('appNonce')?.value
  }, [])

  return (
    <div>
      {appNonce && <Application appNonce={appNonce} applicationId={applicationId} />}
    </div>
  )
}
